import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import { CartProvider } from "./context/CartContext";
import { NotificationProvider } from "./context/NotificationContext";
import Checkout from "./pages/Checkout";


const App = () => {
  return (
    <NotificationProvider>
    <CartProvider>
      <Router>
        <Navbar />
        <main> {/* ✅ main takes available space */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
          </Routes>
        </main>
        <Footer /> {/* ✅ Always at the bottom */}
      </Router>
    </CartProvider>
    </NotificationProvider>
  );
};

export default App;
